import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CrisisBanner from "@/components/CrisisBanner";
import ScrollToTop from "@/components/ScrollToTop";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Team from "@/pages/Team";
import Features from "@/pages/Features";
import ForProviders from "@/pages/ForProviders";
import Download from "@/pages/Download";
import Resources from "@/pages/Resources";
import ResourceDetail from "@/pages/ResourceDetail";
import Stories from "@/pages/Stories";
import StoryDetail from "@/pages/StoryDetail";
import Events from "@/pages/Events";
import Donate from "@/pages/Donate";
import DonateSuccess from "@/pages/DonateSuccess";
import Partner from "@/pages/Partner";
import Contact from "@/pages/Contact";
import FAQ from "@/pages/FAQ";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import GSEDeck from "@/pages/GSEDeck";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { DomTranslator } from "@/i18n/DomTranslator";

function Layout({ children }) {
  const { pathname } = useLocation();
  const isDeck = pathname.startsWith("/gse");
  if (isDeck) {
    return <div className="App min-h-screen bg-navy">{children}</div>;
  }
  return (
    <div className="App min-h-screen flex flex-col bg-white">
      <CrisisBanner />
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

function App() {
  useEffect(() => {
    document.title = "Generational Health — Your mind. Your power.";
  }, []);

  return (
    <LanguageProvider>
    <BrowserRouter>
      <DomTranslator />
      <ScrollToTop />
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#0A1F3D",
            color: "white",
            border: "none",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
      <Layout>
        <Routes>
          <Route path="/gse" element={<GSEDeck />} />
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/team" element={<Team />} />
          <Route path="/features" element={<Features />} />
          <Route path="/for-providers" element={<ForProviders />} />
          <Route path="/download" element={<Download />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/resources/:id" element={<ResourceDetail />} />
          <Route path="/stories" element={<Stories />} />
          <Route path="/stories/:id" element={<StoryDetail />} />
          <Route path="/events" element={<Events />} />
          <Route path="/donate" element={<Donate />} />
          <Route path="/donate/success" element={<DonateSuccess />} />
          <Route path="/partner" element={<Partner />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
      </Layout>
    </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
